export const POST_VIDEOCHAT = "POST_VIDEOCHAT";
export const FETCH_ALL_VIDEOCHATS = "FETCH_ALL_VIDEOCHATS";